import { FC } from "react";
import styles from "./styles.module.scss";

interface Props {
    progressPercent: number;
    label?: string;
    eligibilityLabel: string;
    remainingConditionsCount: number;
}

const GraduationSummaryCard: FC<Props> = ({
    progressPercent,
    label,
    eligibilityLabel,
    remainingConditionsCount,
}) => {
    const safeProgress = Math.max(0, Math.min(100, progressPercent));
    const normalizedEligibilityLabel = eligibilityLabel
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase();
    const isEligible =
        (normalizedEligibilityLabel.includes("eligible") ||
            normalizedEligibilityLabel.includes("valide")) &&
        !normalizedEligibilityLabel.includes("non");
    const isPendingLaunch =
        normalizedEligibilityLabel.includes("promotion non lancee");
    const isStaffAccount = normalizedEligibilityLabel.includes("compte staff");
    const isInProgress =
        !isPendingLaunch &&
        !isStaffAccount &&
        normalizedEligibilityLabel.includes("progression");

    return (
        <div className={styles.card}>
            <div className={styles.summaryTwoCols}>
                <section className={styles.summaryCol}>
                    <h3 className={styles.cardTitle}>
                        Progression
                    </h3>
                    <span className={styles.progressValue}>{safeProgress}%</span>
                    <div className={styles.progressBarTrack} aria-hidden>
                        <div
                            className={styles.progressBarFill}
                            style={{ width: `${safeProgress}%` }}
                        />
                    </div>
                    <p className={styles.cardSubtitle}>{label ?? "\u00A0"}</p>
                </section>

                <section className={styles.summaryCol}>
                    <h3 className={styles.cardTitle}>Statut actuel</h3>
                    <span
                        className={
                            isPendingLaunch || isStaffAccount
                                ? styles.statusPending
                                : isEligible
                                  ? styles.statusOk
                                  : isInProgress
                                    ? styles.statusInProgress
                                    : styles.statusNotOk
                        }
                    >
                        {eligibilityLabel}
                    </span>
                    <p className={styles.cardSubtitle}>
                        {isStaffAccount
                            ? "Hors parcours trader"
                            : isPendingLaunch
                              ? "La promotion n'a pas encore commencé"
                              : remainingConditionsCount > 0
                                ? `${remainingConditionsCount} critère${
                                      remainingConditionsCount > 1 ? "s" : ""
                                  } restant${
                                      remainingConditionsCount > 1 ? "s" : ""
                                  } à valider`
                                : "Tous les critères sont validés"}
                    </p>
                </section>
            </div>
        </div>
    );
};

export default GraduationSummaryCard;
